import { render, staticRenderFns } from "./ProjectSupervisorCollaboratorList.vue?vue&type=template&id=cf827b38&scoped=true&"
import script from "./ProjectSupervisorCollaboratorList.vue?vue&type=script&lang=js&"
export * from "./ProjectSupervisorCollaboratorList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSupervisorCollaboratorList.vue?vue&type=style&index=0&id=cf827b38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf827b38",
  null
  
)

export default component.exports